import axios, { AxiosRequestConfig } from "axios";
import getAxiosConfig from "../other/axiosConfig";

const getUserLoginInfo = async (
  email: string,
  password: string,
): Promise<string> => {
  const configData = {
    email,
    password,
  };

  const config: AxiosRequestConfig = getAxiosConfig(
    "POST",
    "/users-auth/login",
    "Content-Type",
    configData,
  );

  const response = await axios(config);
  const { data } = response;
  const { code } = data;

  if (code !== 200) {
    throw new Error("Invalid email or password");
  }

  const { data: jwtAuthToken } = data;
  return jwtAuthToken;
};

export default getUserLoginInfo;
